import { render } from "./Loading.vue?vue&type=template&id=3bdeb5db&scoped=true&ts=true"
import script from "./Loading.vue?vue&type=script&lang=ts"
export * from "./Loading.vue?vue&type=script&lang=ts"

import "./Loading.vue?vue&type=style&index=0&id=3bdeb5db&lang=css&scoped=true"

import exportComponent from "/container/procurement-dev.jd.net.nz/application/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bdeb5db"]])

export default __exports__